// src/components/store/sections/gallery/GalleryV64BentomosaicTealLagoon.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV64BentomosaicTealLagoon(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={64}
      archKey="bento_mosaic"
      archLabel="Bento Mosaic Lookbook"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
